module.exports = __webpack_public_path__ + "img/game_pc_km.157180c0.png";